import React from 'react';
import {ErrorBlock} from 'antd-mobile';
export default function ErrorPage(){
    return (
        <div id="error-page">
            <ErrorBlock status='empty' />
        </div>
    );
}